/* eslint-disable  */

import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  root: {
    margin: '24px 0',
    flexGrow: 1,
    '& .MuiInputAdornment-positionEnd > button': {
      color: colors.black,
      padding: '0px',
    },
    '& .MuiInputBase-root': {
      height: '40px',
    },
    '& .MuiButtonBase-root': {
      cursor: 'default',
    },
  },
});

export default useStyles;
